export const termsConditions = [
    {
        id: "service",
        title: "1. Service Agreement",
        content:
            "By purchasing a Host-Age service, you agree to use the service according to applicable laws and Host-Age policies.",
    },
    {
        id: "payment",
        title: "2. Payment & Billing",
        content:
            "All payments must be completed before the selected service is activated. Applicable taxes may be added to the final amount.",
    },
    {
        id: "renewal",
        title: "3. Renewal",
        content:
            "Services may be renewed according to the applicable renewal price and billing cycle.",
    },
    {
        id: "acceptable-use",
        title: "4. Acceptable Use",
        content:
            "Customers must not use Host-Age services for illegal activities, spam, malware, abuse, or activities that may harm the infrastructure.",
    },
    {
        id: "refund",
        title: "5. Refund Policy",
        content:
            "Refund eligibility is subject to the applicable Host-Age refund policy and the service purchased.",
    },
    {
        id: "privacy",
        title: "6. Privacy",
        content:
            "Customer information is handled according to the applicable Host-Age privacy policy.",
    },
];
